import { Col, Form, Radio, Row } from 'antd';
import React, { useState } from 'react';
import { change, initialize } from 'redux-form';

import { useDispatch } from 'react-redux';

interface IPropRadio {
  input;
  idComponent;
  meta;
  classNameLabel?;
  label?;
  disabled?;
  data;
  dataOption;
  layout?;
  formClassName?;
  addtionalFunction?;
  addtionalLabel?;
  radioType?;
  className?;
  formStyle?;
  labelIsRequired?;
  formName;
  initialValues?;
  type?;
  valueName?;
}

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
  marginBottom: '7px',
};

export const RadioButton = (props: IPropRadio) => {
  const {
    input,
    meta: { error },
    idComponent,
    classNameLabel,
    label,
    disabled,
    data,
    dataOption,
    layout,
    formClassName,
    addtionalFunction,
    addtionalLabel,
    radioType,
    className,
    labelIsRequired,
    valueName,
  } = props;
  const [count, setcount] = useState(0);
  const handleOnChange = e => {
    input.onChange(e);
    if (addtionalFunction) {
      addtionalFunction(e);
    }
    setcount(count + 1);
  };

  const additionalLabel = () => {
    if (addtionalLabel) {
      return ` ${addtionalLabel}`;
    } else {
      return null;
    }
  };

  const lebelRequired = () => {
    if (labelIsRequired) {
      return <span className="labelRequired">*</span>;
    }
    return null;
  };
  const labelTitle = label ? (
    <span>
      <b className={`capital ${classNameLabel}`}>{label}</b>
      <span className="colorLightGrey">{additionalLabel()}</span>
      {lebelRequired()}
    </span>
  ) : null;
  const items = (data || dataOption).map(data => {
    if (radioType === 'button') {
      return (
        <Radio.Button
          value={valueName ? data[valueName] : data.id}
          key={`radioValue${data.id}`}
          id={`radioValue${data.id}`}
          style={layout === 'vertical' ? radioStyle : undefined}
        >
          {data.icon ? data.icon : null}
          {data.component === undefined ? data.name : data.component}
        </Radio.Button>
      );
    }
    return (
      <Radio
        value={valueName ? data[valueName] : data.id}
        key={`radioValue${data.id}`}
        id={`radioValue${data.id}`}
        style={layout === 'vertical' ? radioStyle : undefined}
      >
        {data.component === undefined ? data.name : data.component}
      </Radio>
    );
  });
  return (
    <Form.Item
      validateStatus={count > 0 && error !== undefined ? 'error' : ''}
      help={count > 0 && error !== undefined ? error : ''}
      label={labelTitle}
      colon={false}
      className={formClassName}
    >
      <Radio.Group
        id={idComponent}
        onChange={e => handleOnChange(e)}
        disabled={disabled}
        value={input.value}
        onBlur={input.onBlur}
        className={className}
        // {...input}
      >
        {items}
      </Radio.Group>
    </Form.Item>
  );
};

export const RadioButtonIcon = (props: IPropRadio) => {
  const {
    meta: { error },
    classNameLabel,
    label,
    data,
    dataOption,
    layout,
    formClassName,
    addtionalLabel,
    labelIsRequired,
    input,
    idComponent,
    disabled,
    formName,
    className,
    initialValues,
  } = props;
  const [count] = useState(0);
  const dispatch = useDispatch();
  const handleOnChange = e => {
    input.onChange(e);
    dispatch(change(formName, `${e.target.value}`, null));
    dispatch(change(formName, `${e.target.value}Cover`, null));
    dispatch(change(formName, 'file', null));
    dispatch(change(formName, 'fileName', null));
    dispatch(change(formName, 'thumbnail', null));
    if (initialValues) {
      initialValues.file = null;
      initialValues.fileName = null;
      initialValues.thumbnail = null;
      initialValues.fileType = e.target.value;
      dispatch(initialize(formName, initialValues));
    }
  };

  const additionalLabel = () => {
    if (addtionalLabel) {
      return ` ${addtionalLabel}`;
    } else {
      return null;
    }
  };

  const lebelRequired = () => {
    if (labelIsRequired) {
      return <span className="labelRequired">*</span>;
    }
    return null;
  };
  const labelTitle = label ? (
    <span>
      <b className={`capital ${classNameLabel}`}>{label}</b>
      <span className="colorLightGrey">{additionalLabel()}</span>
      {lebelRequired()}
    </span>
  ) : null;
  const items = (data || dataOption).map(item => {
    return (
      <Col span={12} key={item.id}>
        <Radio.Group
          id={idComponent}
          onChange={e => handleOnChange(e)}
          disabled={disabled}
          value={input.value}
          onBlur={input.onBlur}
          className={className}
        >
          <Radio.Button
            value={item.id}
            key={`radioValue${item.id}`}
            id={`radioValue${item.id}`}
            style={layout === 'vertical' ? radioStyle : undefined}
            className={item.className}
            disabled={disabled}
          >
            {item.icon ? item.icon : null}
            {item.component === undefined ? item.name : item.component}
          </Radio.Button>
        </Radio.Group>
      </Col>
    );
  });
  return (
    <Form.Item
      validateStatus={count > 0 && error !== undefined ? 'error' : ''}
      help={count > 0 && error !== undefined ? error : ''}
      label={labelTitle}
      colon={false}
      className={formClassName}
    >
      <Row gutter={24}>{items}</Row>
    </Form.Item>
  );
};
